import gql from 'graphql-tag';

// Get my ventures data
export const MY_VENTURES = gql`
  query get_my_ventures_data($userId: Int) {
    account(userId: $userId) {
        id
        userId
        ventures {
            nodes {
                id
                venture_id
                title
                permalink
                tagline
                has_logo
                country_rank
                sector_rank
                logo_url
                edit_link
            }
        }
    }
}
`;

// Get my ventures data matching mentor.
export const MY_VENTURES_MATCHING_MENTOR = gql`
query get_my_ventures_data($where: ConnectionAccountMentorVenturesWhereArgs) {
    venturesForMentor(where: $where) {
        pageInfo {
            hasNextPage
            endCursor
            startCursor
        }
        edges {
            cursor
            node {
                id
                venture_id
                title
                permalink
                tagline
                has_logo
                country_rank
                sector_rank
                logo_url
                edit_link
            }
        }
    }
}
`;
